import React, { useEffect, useState } from 'react';
import {
   Card,
   Col, Container,
   Row,
} from 'reactstrap';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import SignInForm from './SignInForm';
import NavbarLite from '../../../components/NavbarLite';
import { getDefaultPartnerLandingPath } from './util';
import { resolvePostLoginRedirect } from 'util/auth/postLoginRedirect';


const SignInJobcase = (props) => {
   const history = useHistory();
   const location = useLocation();

   /*
    * DE shutdown: a deliberately understated [Jobcase | Direct Employer] toggle sits
    * above the form. Jobcase is always the default; the Direct Employer side only
    * exists so retired-DE customers who go looking for their old sign-in find the
    * "contact Customer Success" note - nobody sees DE messaging unless they click.
    */
   const [activeLoginTab, setActiveLoginTab] = useState('jobcase');

   // The intl login shares this component; intl partners never had DE, no toggle there.
   const showLoginTabs = !location?.pathname?.toLocaleLowerCase()?.includes('intl');

   const loginTabStyle = (isActive) => ({
      background: 'none',
      border: 'none',
      borderBottom: isActive ? '2px solid #8C8C8C' : '2px solid transparent',
      color: isActive ? '#595959' : '#C4C4C4',
      cursor: 'pointer',
      fontSize: '13px',
      fontWeight: isActive ? '600' : '400',
      padding: '4px 2px',
      marginRight: '16px',
   });

   /**
    * Redirects the user if they once logged in as partner.
    */
   useEffect(() => {
      if (props.isLoggedInPartner) {
         const defaultLandingPath = getDefaultPartnerLandingPath(props.loggedInUserPartner)
            || '/401/pt';

         const from = location?.state?.from || new URLSearchParams(location.search).get('from');
         history.push(resolvePostLoginRedirect(from, defaultLandingPath));
      }
   }, [props.isLoggedInPartner, props.loggedInUserPartner, location.search, location.state]);

   return (
      <>
         <NavbarLite/>
         <Container
            className='absolute-center'
            style={{
               // used to cancel out the margin of the .main class
               marginTop: '-3.5rem',
               fontFamily: 'Founders Grotesk, Arial, sans-serif',
            } }
         >
            <Row>
               <Col sm={12} md={9} lg={6} className='mx-auto' >
                  <Card
                     style={{
                        maxWidth: '416px',
                        // maxWidth: '382px',
                     }}
                     className='mx-auto'
                  >
                     <div className='p-3'>
                        { showLoginTabs && (
                           <div className='mb-3'>
                              <button
                                 type='button'
                                 style={ loginTabStyle(activeLoginTab === 'jobcase') }
                                 onClick={ () => setActiveLoginTab('jobcase') }
                              >
                                 Partners
                              </button>
                              <button
                                 type='button'
                                 style={ loginTabStyle(activeLoginTab === 'directEmployer') }
                                 onClick={ () => setActiveLoginTab('directEmployer') }
                              >
                                 Direct Employers
                              </button>
                           </div>
                        ) }
                        <h1
                           aria-level='1'
                           style={{
                              color: '#262626',
                              fontSize: '36px',
                              fontWeight: '500',
                              lineHeight: '42px',
                           }}
                           className='mb-4'
                        >
                           Welcome Back!
                        </h1>
                        { activeLoginTab === 'jobcase' && (
                           <>
                              <p
                                 style={{
                                    color: '#595959',
                                    fontSize: '15px',
                                    lineHeight: '21px',
                                 }}
                                 className='mb-4'
                              >
                                 Sign in with your Jobcase.com email and password.
                              </p>
                              <SignInForm/>
                              <div className='text-center mt-4'>
                                 <a
                                    href='https://www.jobcase.com/password/recover?email='
                                    style={{
                                       color: '#2C04BD',
                                       fontWeight: '600',
                                       fontSize: '16px',
                                       textDecoration: 'none',
                                    }}
                                 >
                                    Forgot password?
                                 </a>
                              </div>
                              <div className='text-center mt-3'>
                                 <span
                                    style={{
                                       color: '#595959',
                                       fontSize: '15px',
                                    }}
                                 >
                                    New partner?{ ' ' }
                                 </span>
                                 <a
                                    href='https://www.jobcase.com/employer-onboarding-partners?utm_source=UpwardPartner'
                                    style={{
                                       color: '#2C04BD',
                                       fontWeight: '600',
                                       fontSize: '15px',
                                       textDecoration: 'none',
                                    }}
                                 >
                                    Create an account
                                 </a>
                              </div>
                           </>
                        ) }
                        { activeLoginTab === 'directEmployer' && (
                           <p
                              style={{
                                 color: '#595959',
                                 fontSize: '15px',
                                 lineHeight: '22px',
                              }}
                              className='mb-4'
                           >
                              Direct Employer sign-in is no longer available on this
                              site. Please reach out to your Customer Success
                              representative &mdash; they&apos;ll help you transition
                              your account.
                           </p>
                        ) }
                     </div>
                  </Card>
               </Col>
            </Row>
         </Container>
      </>
   );
};

const mapStateToProps = (state) => ({
   isLoggedInPartner: state.authReducer.isLoggedInPartner,
   loggedInUserPartner: state.authReducer.loggedInUserPartner,
});

export default connect(
   mapStateToProps,
)(SignInJobcase);
